import { TodoResource } from './resource'

export default {
  getConfigInfo: TodoResource.getConfigInfo,
  updateConfigInfo: TodoResource.updateConfigInfo,
  createTodo: TodoResource.createTodo,
  updateTodo: TodoResource.updateTodo,
  deleteTodo: TodoResource.deleteTodo,
  getTodos: TodoResource.getTodos,
  updateTodoOrder: TodoResource.updateTodoOrder,
  wxAjax: TodoResource.wxAjax
}



/** WEBPACK FOOTER **
 ** ./src/api/index.js
 **/